import { analytics_summary_route, VITE_API_URL } from "@/constants";
import type { AuthFetchParams } from "./global";
import { queryOptions } from "@tanstack/react-query";
import type { AnalyticsSummary } from "@/lib/types";

async function getAnalyticsSummary(params: AuthFetchParams) {
  const res = await fetch(`${VITE_API_URL}${analytics_summary_route}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${params.token}`,
      "X-Inventoree-Organization": params.orgId,
    },
    credentials: "include",
  });

  const access = res.headers.get("access-token");
  if (access) params.setToken(access);

  return (await res.json()) as AnalyticsSummary;
}

export const analyticsQueryOpts = (params: AuthFetchParams) =>
  queryOptions({
    queryKey: [params.orgId, "analytics", "summary"],
    queryFn: async () => await getAnalyticsSummary(params),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
